<template>
<div class="financing_data">
    <!-- 投融资报告 -->
    <div class="list_div">
        <Table :columns="columns" :data="list"></Table>
    </div>
    <div class="page clear" v-if="total > 10">
        <Page :total="total" :page-size="10" show-total class="page_list" @on-change="handlePage" show-elevator/>
    </div>
    <Contanct></Contanct>
    <Spin fix v-if="spinShow">
        <Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon>
        <div>Loading</div>
    </Spin>
    <Modal
        v-model="reportIndex"
        @on-visible-change="reportModalCancel"
        :footer-hide="true"
        width="458"
        class="page-modal"
    >
        <img :src="$store.state.static_img_url + 'pic/model/report-upload-model.png'" />
        <p class="p1">亲，今日下载量已耗尽~</p>
        <p class="p2">成为VIP会员， 下载量不受限。</p>
        <router-link to="/buyVip" class="go-vip-btn">立即成为VIP会员</router-link>
    </Modal>
</div>
</template>

<script>
import filter from 'js/filter'
import Contanct from '../Contanct'
import { eventReport, getNumOfreadReport } from '../../../../service'
// let index_r = 0
export default {
  inject: ['login','is_vip'],
  components: {
    Contanct
  },
  computed: {
    user_key() {
      return this.$store.state.user_key
    }
  },
  data() {
    return {
      spinShow: true,
      total: 0,
      page: 1,
      list: [],
      li_index: 0,
      reportIndex: false,
      columns: [
        // { title: '排名', width: 110, align: 'center',render: (h, params) => {
        //   index_r++
        //   if(index_r < 4) {
        //     return h('img', { attrs: {src: require('../../../../assets/pic/top'+index_r+'.png')}})
        //   }else{
        //     return h('span', index_r)
        //   }
        // }},
        { title: '名称', minWidth: 220, render:(h, params) => {
          return h('span', params.row.title)
        }},
        { title: '出品人', width: 180, render:(h, params) => {
          return h('span', filter.empty(params.row.src_author))
        }},
        { title: '发布时间', width: 170, render:(h, params) => {
          return h('span', filter.timeTrans(params.row.publish_time))
        }},
        { title: '下载量', width: 170, render:(h, params) => {
          return h('span', params.row.puv ? parseInt(params.row.puv) + 299 : 299)
        }},
        { title: '操作', width: 90, render:(h, params) => {
          if(this.user_key){
            return h('a',{
              attrs:{
                // href: 'https://vcbeat.top'+params.row.file_path,
                href: 'javascript:void(0)'
                // target: '_blank'
              },
              on: {
                click: () => {
                  _czc.push(['_trackEvent', '投融资报告', '投融资报告下载（'+params.row.title+'）'])
                  // if(item.price > 0) {
                  //   this.$router.push({name: 'ReportDetail', params: {uid: item.uid}})
                  // } else {
                    if (this.had_read_report.indexOf(params.row.id) == -1) {
                      this.getNumOfreadReport(params.row.uid)
                    } else {
                      let q = JSON.stringify({user_key: this.user_key, uid: params.row.uid})
                      window.open(this.$store.state.req_url + '/dg/reportfile?query=' + q)
                    }
                  // }
                }
              },
              class: {upload_ico: true}
            }, [
              h('i', {class: {iconfont: true}, domProps: {
                innerHTML: '&#xe644;'
              }}),
              h('span','下载')
            ])
          }else{
            return h('a',{
              on: {
                click: () => {
                  _czc.push(['_trackEvent', '投融资报告', '投融资报告下载（'+params.row.title+'）'])
                  this.login()
                }
              },
              class: {upload_ico: true}
            }, [
              h('i', {class: {iconfont: true}, domProps: {
                innerHTML: '&#xe644;'
              }}),
              h('span','下载')
            ])
          }
        }},
      ],
      had_read_report: []
    }
  },
  methods: {
    async getList() {
      let res = await eventReport({page: this.page}, (error) => { this.$Message.error('请求错误！') })
      if(res.status == 'success') {
        this.list = res.res
        this.total = res.count
        this.spinShow = false
      } else {
        this.$Message.error(res.message)
      }
    },
    handlePage(page) {
      this.page = page
      // index_r = (page - 1) * 10
      this.getList()
    },
    async getNumOfreadReport(uid) {
      let res = await getNumOfreadReport( {user_key: this.user_key}, (error) => {
        this.$Message.error('请求错误！')
      })
      if (res.status == 'success') {
        if(res.res < 10 || this.is_vip) {
          let q = JSON.stringify({user_key: this.user_key, uid: uid})
          window.open(this.$store.state.req_url + '/dg/reportfile?query=' + q)
        } else {
          this.reportIndex = true
        }
        this.had_read_report = res.report_ids
      } else {
        this.$Message.error(res.message)
      }
    },
    reportModalCancel(value) {
      this.reportIndex = value
    }
  },
  created() {
    // index_r = 0
    this.getList()
  },
  destroyed() {
    // index_r = 0
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/common.stylus'
@import '~styles/financing.stylus'
.financing_data
  .list_div
    padding-top: 0
  & >>> a.upload_ico
    color: rgba(250, 122, 80, 1)
    &:hover
      color: #FC9C7C !important
  & >>> .ivu-rate
    font-size: 0
    .ivu-rate-star
      font-size: 10px
      margin-right: 2px
    .ivu-rate-star-full:before
    .ivu-rate-star-half .ivu-rate-star-content:before
      color: #F9C033
  & >>> .ivu-table-wrapper
    .ivu-table
      td
        height: 66px
        line-height: 22px
      tr
        td:first-of-type
        th:first-of-type
          .ivu-table-cell
            padding-right: 36px !important
            line-height: 1
.page-modal
  >>> .ivu-modal
    top: 50%
    margin-top: -140px
  >>> .ivu-modal-content
    border-radius: 0
    height: 280px
    background: url('~pic/model/vip-model.png') no-repeat
    background-size: 100%
    .ivu-modal-close
      right: 8px
      top: 8px
      .ivu-icon-ios-close
        color: #ddd
        &:hover
          color: #553204
  >>> .ivu-modal-body
    padding: 0
    text-align: center
    font-size: 0
    img
      width: 120px
      height: 120px
      margin-top: -55px
    .p1
      color: #553204
      font-size: 24px
      font-weight:600
      margin-top: 22px
    .p2
      color: #553204
      font-size: 16px
      margin-top: 12px
    .go-vip-btn
      inlineBlock()
      width:150px
      height:40px
      background:rgba(255,234,197,1)
      border-radius:20px
      color: #553204
      font-size:14px
      text-align: center
      line-height: 40px
      margin-top: 40px
</style>
